module.exports = {
  annotate: require(68).annotate,
  Module: require(71),
  Injector: require(70)
};
